// extracted by mini-css-extract-plugin
export default {"heroWrapper":"Hero_heroWrapper__WfEhW","midText":"Hero_midText__gkBMh","loginBtn":"Hero_loginBtn__r5fqX"};